define(function(require) {
    const _ = require('underscore');

    /**
     * Cell to handle expanding a row to show more detail
     * @param {Object} options
     * @returns column definition
     */
    const ExpandCell = function(options) {
        return _.extend(
            {
                class: 'details-control',
                prefix: 'expander',
                orderable: false,
                data: null,
                defaultContent: '',
                width: '20px',
                sortable: false,
                expanderContent: row => {
                    // Orverride to return the html for the expander
                    return '';
                }
            },
            options
        );
    };
    return ExpandCell;
});
